import React from 'react';
import PropTypes from 'prop-types';
import styles from './instoreCollection.module.scss';
import { Button } from '../../ds';
import { ReactComponent as RefreshIconMobile } from './assets/refresh-icon-mobile.svg';
import { ReactComponent as RefreshIcon } from './assets/refresh-icon.svg';

const TableSection = ({ children, isMobile, onRefresh }) => (
  <div className={styles.table}>
    <div className={styles.tableActionBar}>
      <div className={styles.tableLeftSection}>
        <h2>Órdenes del día</h2>
      </div>
      <div className={styles.tableRightSection}>
        <Button type='link' size='small' onClick={onRefresh}>
          {isMobile ? (
            <RefreshIconMobile />
          ) : (
            <>
              <RefreshIcon />
              <span>Actualizar</span>
            </>
          )}
        </Button>
      </div>
    </div>
    <div className={styles.ordersTableContainer}>{children}</div>
  </div>
);

TableSection.propTypes = {
  children: PropTypes.node.isRequired,
  isMobile: PropTypes.bool.isRequired,
  onRefresh: PropTypes.func.isRequired,
};

export default TableSection;
